import Vue from 'vue'
import VueRouter from 'vue-router'
import CardKey from '../views/CardKey.vue'
import Home from '../views/Home.vue'
import GoodsList from '../views/GoodsList.vue'
import OrderDetail from '../views/OrderDetail.vue'

Vue.use(VueRouter)

const routes = [
  {
    path: '/',
    redirect: to => ({ path: '/cardkey', query: to.query }),
  },
  {
    path: '/cardkey',
    name: 'CardKey',
    component: CardKey,
  },
  {
    path: '/shop-list',
    name: 'Home',
    component: Home,
  },
  {
    path: '/goods-list',
    name: 'GoodsList',
    component: GoodsList,
  },
  {
    path: '/order-detail',
    name: 'OrderDetail',
    component: OrderDetail,
  },
]

const router = new VueRouter({
  routes,
})

export default router
